<div class="avatar">
  <ng-content select="[avatarSlot]" />
</div>
<div class="hint">
  <ng-content select="[hintSlot]" />
</div>
<div class="user">
  <ng-content select="[userSlot]" />
</div>
